export type Language = 'it' | 'en'

export const translations = {
  it: {
    common: {
      back: 'Indietro',
      next: 'Avanti',
      submit: 'Invia Segnalazione',
      startReport: 'Inizia Segnalazione',
      loading: 'Caricamento...',
      guestServices: 'Servizi Ospiti',
      roomBadge: 'Stanza 102',
      required: 'Obbligatorio',
      logout: 'Esci',
      wifi: {
        title: 'WiFi Appartamento',
        password: 'Password',
      },
    },
    login: {
      title: 'Benvenuto a Villa Serenity',
      subtitle: 'Seleziona la modalità di accesso per continuare',
      roles: {
        host: 'Host',
        fornitore: 'Fornitore Pulizie',
        manutenzione: 'Manutenzione',
      },
      roleDescriptions: {
        host: 'Gestisci proprietà e ospiti',
        fornitore: 'Gestisci ordini e forniture',
        manutenzione: 'Gestisci segnalazioni e interventi',
      },
      loginButton: 'Accedi',
      or: 'oppure',
      guestButton: 'Accedi come Guest',
    },
    fornitore: {
      dashboard: {
        title: 'Indicazioni Speciali Host',
        subtitle: 'Gestisci ordini e forniture',
      },
      beforePhotos: {
        title: 'Foto Prima',
        subtitle: 'Scatta le foto di ogni ambiente prima di iniziare',
        progress: '{current}/{total} ambienti',
        takePhoto: 'Scatta foto',
        photoTaken: 'Foto scattata',
        reportProblem: 'Segnala un problema',
        startCleaning: 'Inizia pulizia',
        rooms: {
          soggiorno: 'Soggiorno',
          cucina: 'Cucina',
          bagno: 'Bagno',
          camera1: 'Camera 1',
          camera2: 'Camera 2',
          ingresso: 'Ingresso',
        },
      },
      afterPhotos: {
        title: 'Foto Dopo',
        subtitle: 'Scatta le foto di ogni ambiente dopo la pulizia',
        progress: '{current}/{total} completate',
        before: 'Prima',
        after: 'Dopo',
        takePhoto: 'Scatta foto',
        photoTaken: 'Foto scattata',
        tip: 'Riprendi dalla stessa angolazione',
        reportProblem: 'Segnala un problema',
        confirmCompletion: 'Conferma conclusione',
      },
      camera: {
        alignWithReference: 'Allinea con la foto reference',
        tip: 'Cerca di mantenere la stessa angolazione e illuminazione',
        capture: 'Scatta',
      },
      reportProblem: {
        title: 'Segnala un Problema',
        step: 'Step {current} di {total}',
        cancel: 'Annulla',
        continue: 'Continua',
        step1: {
          title: 'Che tipo di problema hai riscontrato?',
          options: {
            excessiveDirt: {
              title: 'Sporco Eccessivo',
              description:
                'Lo spazio richiede più tempo di pulizia del previsto',
            },
            missingMaterial: {
              title: 'Materiale Mancante',
              description: 'Prodotti o attrezzature necessarie non disponibili',
            },
            brokenItem: {
              title: 'Oggetto Rotto',
              description:
                'Danni o malfunzionamenti che richiedono riparazione',
            },
            other: {
              title: 'Altro',
              description: 'Un problema non elencato sopra',
            },
          },
        },
        step2: {
          title: 'Dettagli del Problema',
          canResolve: {
            question: 'Puoi risolvere il problema oggi?',
            yesWithTime: 'Sì, con tempo extra',
            noBlocking: 'No, è bloccante',
          },
          extraTime: {
            label: 'Quanto tempo extra ti serve?',
            options: {
              '15min': '15 minuti',
              '30min': '30 minuti',
              '45min': '45 minuti',
              '60min': '1 ora',
            },
          },
          affectedArea: {
            label: 'Quale area è interessata?',
            options: {
              soggiorno: 'Soggiorno',
              cucina: 'Cucina',
              bagno: 'Bagno',
              camera1: 'Camera 1',
              camera2: 'Camera 2',
              ingresso: 'Ingresso',
              multiple: 'Più aree',
            },
          },
          damageSeverity: {
            label: 'Gravità del danno',
            options: {
              '1': 'Minimo',
              '2': 'Lieve',
              '3': 'Moderato',
              '4': 'Grave',
              '5': 'Critico',
            },
          },
          description: {
            label: 'Descrizione dettagliata',
            placeholder: 'Descrivi il problema in dettaglio...',
          },
        },
        step3: {
          title: 'Aggiungi Foto',
          subtitleRequired:
            'Scatta foto del problema per aiutarci a capire meglio',
          subtitleOptional:
            'Le foto sono opzionali per questo tipo di problema',
          addPhoto: 'Aggiungi foto',
          tip: 'Scatta foto chiare e ben illuminate del problema',
        },
        step4: {
          title: 'Conferma Segnalazione',
          subtitle: 'Verifica i dettagli prima di inviare',
          type: 'Tipo',
          resolvability: 'Risolvibilità',
          area: 'Area',
          severity: 'Gravità',
          description: 'Descrizione',
          photos: 'Foto',
          noPhotos: 'Nessuna foto allegata',
          infoNote: 'Riceverai aggiornamenti sullo stato della segnalazione',
          submit: 'Invia Segnalazione',
          edit: 'Modifica',
          badges: {
            blocking: 'Bloccante',
            resolvableWith: 'Risolvibile con {time} extra',
          },
        },
      },
      summary: {
        title: 'Riepilogo Intervento',
        duration: 'Durata totale',
        addressCard: {
          address: 'Indirizzo',
          date: 'Data',
          time: 'Orario',
        },
        hostInstructions: {
          title: 'Indicazioni Host Seguite',
          allCompleted: 'Tutte le indicazioni sono state seguite',
        },
        photoComparison: {
          title: 'Confronto Foto',
          before: 'Prima',
          after: 'Dopo',
        },
        reportedIssues: {
          title: 'Problemi Segnalati',
          noIssues: 'Nessun problema segnalato',
        },
        submitButton: 'Invia e Concludi',
        aiNote: 'Le foto verranno analizzate dal sistema CleanAI',
      },
      cleaningInProgress: {
        title: 'Pulizia in Corso',
        timerLabel: 'Tempo Trascorso',
        hostPreferences: 'Preferenze Host',
        preferredProducts: 'Prodotti Preferiti',
        avoidProducts: 'Prodotti da Evitare',
        specialPreferences: 'Preferenze Speciali',
        delicateMaterials: 'Materiali Delicati',
        additionalNotes: 'Note Aggiuntive',
        reportProblem: 'Segnala un problema',
        finishCleaning: 'Termina Pulizia',
      },
      reportStatus: {
        title: 'Stato Segnalazione',
        estimatedTime: 'Risoluzione prevista: ~{minutes} minuti',
        timeline: {
          opened: 'Aperta',
          takenInCharge: 'Presa in carico',
          inProgress: 'In lavorazione',
          resolved: 'Risolta',
        },
        problemTypes: {
          brokenItem: '🔧 Oggetto Rotto',
          leak: '💧 Perdita Acqua',
          electrical: '⚡ Problema Elettrico',
          heating: '🌡️ Riscaldamento',
          other: '⚠️ Altro',
        },
      },
    },
    manutenzione: {
      dashboard: {
        title: 'Portale Manutenzione',
        subtitle: 'Intervento di manutenzione richiesto',
        viewDetails: 'Visualizza Dettagli e Inizia Intervento',
        infoNote:
          "💡 Ricordati di scattare le foto del prima prima di iniziare l'intervento",
      },
      beforePhotos: {
        title: 'Foto del Prima',
        subtitle: 'Documenta lo stato attuale del problema',
        progress: '{current} / {min} foto',
        takePhoto: 'Scatta Foto',
        required: 'Richiesta',
        optional: 'Opzionale',
        tips: {
          title: '💡 Suggerimenti per le foto',
          tip1: '• Scatta da diverse angolazioni',
          tip2: '• Assicurati che il problema sia ben visibile',
          tip3: '• Usa una buona illuminazione',
          tip4: '• Minimo {min} foto richieste',
        },
        startIntervention: 'Avvia Intervento',
      },
      reportsDetail: {
        title: 'Dettagli Segnalazione',
        activeReport: '1 segnalazione attiva',
        takeBeforePhotos: 'Scatta Foto del Prima',
        infoNote:
          "Scatta delle foto dello stato attuale del problema. Questo aiuterà a documentare l'intervento e a confrontare il prima e il dopo.",
        infoTitle: "Prima di iniziare l'intervento",
        reportedBy: 'Segnalato da',
        timestamp: 'Orario',
        area: 'Area',
        severity: 'Gravità',
        description: 'Descrizione',
        photos: 'Foto',
        blocking: 'Bloccante',
      },
      intervention: {
        title: 'Intervento in Corso',
        subtitle: 'Intervento in corso',
        timerLabel: 'Tempo Intervento',
        reportToResolve: 'Segnalazione da risolvere',
        markResolved: 'Segna come risolta',
        completed: '✓ Segnalazione completata',
        notes: 'Note intervento (opzionale)',
        notesPlaceholder: "Aggiungi eventuali annotazioni sull'intervento...",
        completeIntervention: 'Concludi Intervento',
      },
      completion: {
        title: 'Concludi Intervento',
        ratingSection: 'Valutazione Segnalazione',
        solutionSection: 'Come hai risolto',
        photoSection: 'Foto Finale',
        descriptionAccuracy: 'Accuratezza descrizione',
        photoAccuracy: 'Accuratezza foto',
        actualSeverity: 'Gravità effettiva',
        solutionType: 'Tipo di soluzione',
        solutionTypes: {
          partial: 'Riparazione parziale',
          partialDesc: 'Il problema è stato risolto temporaneamente',
          complete: 'Riparazione completa',
          completeDesc: 'Il problema è stato risolto definitivamente',
          custom: 'Altro (specifica)',
          customDesc: 'Descrivi il tipo di intervento effettuato',
          customPlaceholder:
            'Es: Sostituzione componente, Pulizia straordinaria...',
        },
        interventionDescription: 'Descrizione intervento',
        interventionPlaceholder:
          'Descrivi brevemente cosa hai fatto... (minimo 15 caratteri)',
        descriptionMinChars: 'Minimo 15 caratteri richiesti ({current}/15)',
        descriptionValid: '✓ Descrizione valida',
        characterCount: '{current}/1000',
        finalPhoto: 'Foto Finale',
        finalPhotoLabel: 'Scatta foto del risultato finale',
        submit: 'Invia e Concludi',
      },
      confirmationPage: {
        title: 'Intervento Completato!',
        subtitle:
          'Grazie per il tuo lavoro. La segnalazione è stata chiusa con successo.',
        summaryTitle: 'Riepilogo',
        property: 'Proprietà',
        interventionType: 'Tipo intervento',
        status: 'Stato',
        statusCompleted: 'Completato',
        backToDashboard: 'Torna alla Dashboard',
        autoRedirect: 'Reindirizzamento automatico tra 5 secondi...',
      },
    },
    host: {
      dashboard: {
        title: 'Portale Host',
        subtitle: 'Gestisci le tue proprietà e ospiti',
        greeting: 'Ciao Marco',
        allGood: 'Tutto OK',
        activeReportsBadge: 'segnalazione attiva',
        quickActionsTitle: 'Azioni Rapide',
        quickActions: {
          referencePhotos: 'Foto Reference',
          interventionsHistory: 'Storico Interventi',
          tabletAccess: 'Accessi Tablet',
        },
        recentActivity: 'Attività Recente',
        activities: {
          cleaningCompleted: 'Pulizia completata',
          maintenanceResolved: 'Manutenzione risolta',
          tabletAccess: 'Accesso tablet',
        },
        viewDetails: 'Vedi dettagli',
      },
      accessHistory: {
        title: 'Accessi Tablet',
        filterAll: 'Tutti',
        filterCleaning: 'Pulizie',
        filterMaintenance: 'Manutenzione',
        entry: 'Ingresso',
        exit: 'Uscita',
        inProgress: 'In corso',
        duration: 'Durata',
        noAccess: 'Nessun accesso registrato in questo periodo',
        roles: {
          fornitore: 'Fornitore Pulizie',
          manutenzione: 'Manutenzione',
        },
      },
      interventionsHistory: {
        title: 'Storico Interventi',
        tabCleaning: 'Pulizie',
        tabMaintenance: 'Manutenzione',
        filterPeriod: {
          last30: 'Ultimi 30 giorni',
          last90: 'Ultimi 3 mesi',
          all: 'Tutto',
        },
        supplier: 'Fornitore',
        operator: 'Operatore',
        duration: 'Durata',
        status: {
          completed: 'Completato',
          withReport: 'Con segnalazione',
          resolved: 'Risolto',
        },
        severity: {
          minor: 'Lieve',
          medium: 'Medio',
          severe: 'Grave',
        },
        resolvedBy: 'Risolto da',
        interventionTime: 'Tempo intervento',
        noInterventions: 'Nessun intervento registrato',
      },
      interventionDetail: {
        title: 'Intervento',
        maintenanceTitle: 'Manutenzione',
        summary: 'Riepilogo',
        date: 'Data',
        time: 'Orario',
        supplier: 'Fornitore',
        operator: 'Operatore',
        totalDuration: 'Durata totale',
        photoComparison: 'Confronto Foto',
        before: 'Prima',
        after: 'Dopo',
        score: {
          excellent: 'Ottimo',
          good: 'Buono',
          needsImprovement: 'Da migliorare',
        },
        preferencesFollowed: 'Preferenze Rispettate',
        problemsFound: 'Problemi Riscontrati',
        resolvedBy: 'Risolto da',
        feedback: {
          title: 'Il tuo Feedback',
          question: 'Come valuteresti questo intervento?',
          placeholder: 'Aggiungi un commento...',
          submit: 'Invia Feedback',
          submitted: 'Feedback inviato il',
        },
        originalReport: 'Segnalazione Originale',
        reportedBy: 'Segnalato da',
        reportDate: 'Data segnalazione',
        resolution: 'Come è stato risolto',
        solutionType: 'Tipo soluzione',
        technicianRating: 'Valutazione del Tecnico',
        descriptionAccuracy: 'Accuratezza descrizione',
        photoAccuracy: 'Accuratezza foto',
        actualSeverity: 'Gravità effettiva',
      },
      referencePhotos: {
        title: 'Foto Reference',
        add: 'Aggiungi',
        infoText:
          'Le foto reference aiutano i fornitori a capire come sistemare ogni ambiente e vengono usate come guida per le foto Prima e Dopo.',
        updated: 'Aggiornata',
        takeNewPhoto: 'Scatta nuova foto',
        uploadFromGallery: 'Carica da galleria',
        confirm: 'Conferma',
        cancel: 'Annulla',
        deleteTitle: 'Eliminare foto reference?',
        deleteMessage:
          "La foto reference per '{room}' verrà eliminata. I fornitori non avranno più una guida per questo ambiente.",
        delete: 'Elimina',
        addNew: {
          title: 'Aggiungi Ambiente',
          roomName: 'Nome ambiente',
          roomPlaceholder: 'Es. Camera ospiti',
          notes: 'Note',
          notesPlaceholder: 'Es. Inquadrare includendo il divano',
          save: 'Salva',
        },
        emptyState: {
          title: 'Nessuna foto reference',
          subtitle:
            'Aggiungi foto per aiutare i fornitori a sistemare gli ambienti nel modo corretto.',
          cta: 'Aggiungi prima foto',
        },
        rooms: {
          soggiorno: 'Soggiorno',
          cucina: 'Cucina',
          bagno: 'Bagno',
          camera1: 'Camera 1',
          camera2: 'Camera 2',
          ingresso: 'Ingresso',
        },
      },
    },
    welcome: {
      greeting: '👋',
      title: 'Come possiamo aiutarti?',
      subtitle: 'How can we help you today?',
      subtitle_translated:
        'Usa questo strumento per segnalare un problema che richiede attenzione',
      categories: {
        cleaning: {
          title: 'Pulizia',
          desc: 'Sporco, macchie, forniture',
        },
        repair: {
          title: 'Riparazione',
          desc: 'Guasti, malfunzionamenti, riparazioni',
        },
      },
    },
    wizard: {
      steps: {
        room: 'Stanza',
        details: 'Dettagli',
        review: 'Riepilogo',
      },
    },
    roomSelection: {
      title: 'Seleziona la stanza',
      subtitle: 'Dove si trova il problema?',
      rooms: {
        kitchen: 'Cucina',
        bedroom: 'Camera da Letto',
        bathroom: 'Bagno',
        livingRoom: 'Soggiorno',
        laundry: 'Lavanderia',
        other: 'Altro',
      },
    },
    problemDescription: {
      title: 'Descrivi il problema',
      subtitle:
        'Fornisci più dettagli possibili per aiutarci a risolvere il problema',
      labels: {
        description: 'Descrizione',
        photos: 'Foto',
        photosCount: '{count}/3 foto aggiunte',
      },
      placeholders: {
        description: 'Descrivi il problema in dettaglio...',
      },
      buttons: {
        addPhoto: 'Aggiungi foto',
      },
      urgency: {
        question: "Il problema impedisce completamente l'utilizzo?",
        yes: 'Sì, non posso usare la stanza/apparecchio',
        no: 'No, posso ancora usarlo con disagio',
      },
      validation: {
        photoRequired: 'Aggiungi almeno 1 foto',
        urgencyRequired: 'Seleziona una risposta',
        descriptionTooShort:
          'La descrizione deve contenere almeno 20 caratteri',
        descriptionTooLong: 'La descrizione non può superare 1000 caratteri',
      },
      characterCount: '{current}/{max} caratteri',
      photoTips: {
        title: 'Consigli per una foto utile',
        tip1: "Inquadra l'intero problema, non solo un dettaglio",
        tip2: 'Assicurati che ci sia buona illuminazione',
        tip3: 'Scatta da vicino per mostrare i dettagli',
        tip4: 'Se possibile, mostra il contesto circostante',
        cancel: 'Annulla',
        openCamera: 'Apri Fotocamera',
      },
    },
    reviewSubmit: {
      title: 'Riepilogo Segnalazione',
      subtitle: 'Verifica le informazioni prima di inviare',
      sections: {
        roomNumber: 'Numero Stanza',
        location: 'Posizione',
        problem: 'Descrizione Problema',
        contact: 'Contatti',
      },
      labels: {
        name: 'Nome',
        email: 'Email',
        phone: 'Telefono',
        enterRoomNumber: 'Inserisci il numero della stanza',
      },
      note: {
        title: 'Nota Importante',
        text: 'Inviando questa segnalazione, confermi che tutte le informazioni fornite sono accurate. Il nostro team di manutenzione esaminerà la tua richiesta e ti contatterà entro 24-48 ore.',
      },
    },
    confirmation: {
      title: 'Grazie!',
      message: 'La tua segnalazione è stata inviata con successo.',
      infoTitle: 'Il nostro team è stato notificato',
      button: 'Torna alla Home',
    },
  },
  en: {
    common: {
      back: 'Back',
      next: 'Next',
      submit: 'Submit Report',
      startReport: 'Start Report',
      loading: 'Loading...',
      guestServices: 'Guest Services',
      roomBadge: 'Room 102',
      required: 'Required',
      logout: 'Logout',
      wifi: {
        title: 'Apartment WiFi',
        password: 'Password',
      },
    },
    login: {
      title: 'Welcome to Villa Serenity',
      subtitle: 'Select your access mode to continue',
      roles: {
        host: 'Host',
        fornitore: 'Cleaning Supplier',
        manutenzione: 'Maintenance',
      },
      roleDescriptions: {
        host: 'Manage properties and guests',
        fornitore: 'Manage orders and supplies',
        manutenzione: 'Manage reports and interventions',
      },
      loginButton: 'Login',
      or: 'or',
      guestButton: 'Continue as Guest',
    },
    fornitore: {
      dashboard: {
        title: 'Supplier Portal',
        subtitle: 'Manage orders and supplies',
      },
      beforePhotos: {
        title: 'Before Photos',
        subtitle: 'Take photos of each room before starting',
        progress: '{current}/{total} rooms',
        takePhoto: 'Take photo',
        photoTaken: 'Photo taken',
        reportProblem: 'Report a problem',
        startCleaning: 'Start cleaning',
        rooms: {
          soggiorno: 'Living Room',
          cucina: 'Kitchen',
          bagno: 'Bathroom',
          camera1: 'Bedroom 1',
          camera2: 'Bedroom 2',
          ingresso: 'Entrance',
        },
      },
      afterPhotos: {
        title: 'After Photos',
        subtitle: 'Take photos of each room after cleaning',
        progress: '{current}/{total} completed',
        before: 'Before',
        after: 'After',
        takePhoto: 'Take photo',
        photoTaken: 'Photo taken',
        tip: 'Retake from the same angle',
        reportProblem: 'Report a problem',
        confirmCompletion: 'Confirm completion',
      },
      camera: {
        alignWithReference: 'Align with reference photo',
        tip: 'Try to maintain the same angle and lighting',
        capture: 'Capture',
      },
      reportProblem: {
        title: 'Report a Problem',
        step: 'Step {current} of {total}',
        cancel: 'Cancel',
        continue: 'Continue',
        step1: {
          title: 'What type of problem did you encounter?',
          options: {
            excessiveDirt: {
              title: 'Excessive Dirt',
              description: 'Space requires more cleaning time than expected',
            },
            missingMaterial: {
              title: 'Missing Material',
              description: 'Required products or equipment not available',
            },
            brokenItem: {
              title: 'Broken Item',
              description: 'Damage or malfunction requiring repair',
            },
            other: {
              title: 'Other',
              description: 'A problem not listed above',
            },
          },
        },
        step2: {
          title: 'Problem Details',
          canResolve: {
            question: 'Can you resolve the problem today?',
            yesWithTime: 'Yes, with extra time',
            noBlocking: "No, it's blocking",
          },
          extraTime: {
            label: 'How much extra time do you need?',
            options: {
              '15min': '15 minutes',
              '30min': '30 minutes',
              '45min': '45 minutes',
              '60min': '1 hour',
            },
          },
          affectedArea: {
            label: 'Which area is affected?',
            options: {
              soggiorno: 'Living Room',
              cucina: 'Kitchen',
              bagno: 'Bathroom',
              camera1: 'Bedroom 1',
              camera2: 'Bedroom 2',
              ingresso: 'Entrance',
              multiple: 'Multiple areas',
            },
          },
          damageSeverity: {
            label: 'Damage severity',
            options: {
              '1': 'Minimal',
              '2': 'Minor',
              '3': 'Moderate',
              '4': 'Severe',
              '5': 'Critical',
            },
          },
          description: {
            label: 'Detailed description',
            placeholder: 'Describe the problem in detail...',
          },
        },
        step3: {
          title: 'Add Photos',
          subtitleRequired:
            'Take photos of the problem to help us understand better',
          subtitleOptional: 'Photos are optional for this type of problem',
          addPhoto: 'Add photo',
          tip: 'Take clear, well-lit photos of the problem',
        },
        step4: {
          title: 'Confirm Report',
          subtitle: 'Review details before submitting',
          type: 'Type',
          resolvability: 'Resolvability',
          area: 'Area',
          severity: 'Severity',
          description: 'Description',
          photos: 'Photos',
          noPhotos: 'No photos attached',
          infoNote: 'You will receive updates on the report status',
          submit: 'Submit Report',
          edit: 'Edit',
          badges: {
            blocking: 'Blocking',
            resolvableWith: 'Resolvable with {time} extra',
          },
        },
      },
      summary: {
        title: 'Intervention Summary',
        duration: 'Total duration',
        addressCard: {
          address: 'Address',
          date: 'Date',
          time: 'Time',
        },
        hostInstructions: {
          title: 'Host Instructions Followed',
          allCompleted: 'All instructions have been followed',
        },
        photoComparison: {
          title: 'Photo Comparison',
          before: 'Before',
          after: 'After',
        },
        reportedIssues: {
          title: 'Reported Issues',
          noIssues: 'No issues reported',
        },
        submitButton: 'Submit and Complete',
        aiNote: 'Photos will be analyzed by CleanAI system',
      },
      cleaningInProgress: {
        title: 'Cleaning in Progress',
        timerLabel: 'Elapsed Time',
        hostPreferences: 'Host Preferences',
        preferredProducts: 'Preferred Products',
        avoidProducts: 'Products to Avoid',
        specialPreferences: 'Special Preferences',
        delicateMaterials: 'Delicate Materials',
        additionalNotes: 'Additional Notes',
        reportProblem: 'Report a problem',
        finishCleaning: 'Finish Cleaning',
      },
      reportStatus: {
        title: 'Report Status',
        estimatedTime: 'Expected resolution: ~{minutes} minutes',
        timeline: {
          opened: 'Opened',
          takenInCharge: 'Taken in charge',
          inProgress: 'In progress',
          resolved: 'Resolved',
        },
        problemTypes: {
          brokenItem: '🔧 Broken Item',
          leak: '💧 Water Leak',
          electrical: '⚡ Electrical Issue',
          heating: '🌡️ Heating',
          other: '⚠️ Other',
        },
      },
    },
    manutenzione: {
      dashboard: {
        title: 'Maintenance Portal',
        subtitle: 'Maintenance intervention required',
        viewDetails: 'View Details and Start Intervention',
        infoNote:
          '💡 Remember to take before photos before starting the intervention',
      },
      beforePhotos: {
        title: 'Before Photos',
        subtitle: 'Document the current state of the problem',
        progress: '{current} / {min} photos',
        takePhoto: 'Take Photo',
        required: 'Required',
        optional: 'Optional',
        tips: {
          title: '💡 Photo tips',
          tip1: '• Take from different angles',
          tip2: '• Ensure the problem is clearly visible',
          tip3: '• Use good lighting',
          tip4: '• Minimum {min} photos required',
        },
        startIntervention: 'Start Intervention',
      },
      reportsDetail: {
        title: 'Report Details',
        activeReport: '1 active report',
        takeBeforePhotos: 'Take Before Photos',
        infoNote:
          'Take photos of the current state of the problem. This will help document the intervention and compare before and after.',
        infoTitle: 'Before starting the intervention',
        reportedBy: 'Reported by',
        timestamp: 'Timestamp',
        area: 'Area',
        severity: 'Severity',
        description: 'Description',
        photos: 'Photos',
        blocking: 'Blocking',
      },
      intervention: {
        title: 'Intervention in Progress',
        subtitle: 'Intervention in progress',
        timerLabel: 'Intervention Time',
        reportToResolve: 'Report to resolve',
        markResolved: 'Mark as resolved',
        completed: '✓ Report completed',
        notes: 'Intervention notes (optional)',
        notesPlaceholder: 'Add any notes about the intervention...',
        completeIntervention: 'Complete Intervention',
      },
      completion: {
        title: 'Complete Intervention',
        ratingSection: 'Report Rating',
        solutionSection: 'How you resolved',
        photoSection: 'Final Photo',
        descriptionAccuracy: 'Description accuracy',
        photoAccuracy: 'Photo accuracy',
        actualSeverity: 'Actual severity',
        solutionType: 'Solution type',
        solutionTypes: {
          partial: 'Partial repair',
          partialDesc: 'The problem was temporarily resolved',
          complete: 'Complete repair',
          completeDesc: 'The problem was permanently resolved',
          custom: 'Other (specify)',
          customDesc: 'Describe the type of intervention performed',
          customPlaceholder: 'E.g.: Component replacement, Deep cleaning...',
        },
        interventionDescription: 'Intervention description',
        interventionPlaceholder:
          'Briefly describe what you did... (minimum 15 characters)',
        descriptionMinChars: 'Minimum 15 characters required ({current}/15)',
        descriptionValid: '✓ Valid description',
        characterCount: '{current}/1000',
        finalPhoto: 'Final Photo',
        finalPhotoLabel: 'Take photo of the final result',
        submit: 'Submit and Complete',
      },
      confirmationPage: {
        title: 'Intervention Completed!',
        subtitle:
          'Thank you for your work. The report has been successfully closed.',
        summaryTitle: 'Summary',
        property: 'Property',
        interventionType: 'Intervention type',
        status: 'Status',
        statusCompleted: 'Completed',
        backToDashboard: 'Back to Dashboard',
        autoRedirect: 'Auto-redirecting in 5 seconds...',
      },
    },
    host: {
      dashboard: {
        title: 'Host Portal',
        subtitle: 'Manage properties and guests',
        greeting: 'Hi Marco',
        allGood: 'All Good',
        activeReportsBadge: 'active report',
        quickActionsTitle: 'Quick Actions',
        quickActions: {
          referencePhotos: 'Reference Photos',
          interventionsHistory: 'Interventions History',
          tabletAccess: 'Tablet Access',
        },
        recentActivity: 'Recent Activity',
        activities: {
          cleaningCompleted: 'Cleaning completed',
          maintenanceResolved: 'Maintenance resolved',
          tabletAccess: 'Tablet access',
        },
        viewDetails: 'View details',
      },
      accessHistory: {
        title: 'Tablet Access',
        filterAll: 'All',
        filterCleaning: 'Cleaning',
        filterMaintenance: 'Maintenance',
        entry: 'Entry',
        exit: 'Exit',
        inProgress: 'In progress',
        duration: 'Duration',
        noAccess: 'No access recorded in this period',
        roles: {
          fornitore: 'Cleaning Supplier',
          manutenzione: 'Maintenance',
        },
      },
      interventionsHistory: {
        title: 'Interventions History',
        tabCleaning: 'Cleaning',
        tabMaintenance: 'Maintenance',
        filterPeriod: {
          last30: 'Last 30 days',
          last90: 'Last 3 months',
          all: 'All',
        },
        supplier: 'Supplier',
        operator: 'Operator',
        duration: 'Duration',
        status: {
          completed: 'Completed',
          withReport: 'With report',
          resolved: 'Resolved',
        },
        severity: {
          minor: 'Minor',
          medium: 'Medium',
          severe: 'Severe',
        },
        resolvedBy: 'Resolved by',
        interventionTime: 'Intervention time',
        noInterventions: 'No interventions recorded',
      },
      interventionDetail: {
        title: 'Intervention',
        maintenanceTitle: 'Maintenance',
        summary: 'Summary',
        date: 'Date',
        time: 'Time',
        supplier: 'Supplier',
        operator: 'Operator',
        totalDuration: 'Total duration',
        photoComparison: 'Photo Comparison',
        before: 'Before',
        after: 'After',
        score: {
          excellent: 'Excellent',
          good: 'Good',
          needsImprovement: 'Needs improvement',
        },
        preferencesFollowed: 'Preferences Followed',
        problemsFound: 'Problems Found',
        resolvedBy: 'Resolved by',
        feedback: {
          title: 'Your Feedback',
          question: 'How would you rate this intervention?',
          placeholder: 'Add a comment...',
          submit: 'Submit Feedback',
          submitted: 'Feedback submitted on',
        },
        originalReport: 'Original Report',
        reportedBy: 'Reported by',
        reportDate: 'Report date',
        resolution: 'How it was resolved',
        solutionType: 'Solution type',
        technicianRating: 'Technician Rating',
        descriptionAccuracy: 'Description accuracy',
        photoAccuracy: 'Photo accuracy',
        actualSeverity: 'Actual severity',
      },
      referencePhotos: {
        title: 'Reference Photos',
        add: 'Add',
        infoText:
          'Reference photos help suppliers understand how to arrange each room and are used as a guide for Before and After photos.',
        updated: 'Updated',
        takeNewPhoto: 'Take new photo',
        uploadFromGallery: 'Upload from gallery',
        confirm: 'Confirm',
        cancel: 'Cancel',
        deleteTitle: 'Delete reference photo?',
        deleteMessage:
          "The reference photo for '{room}' will be deleted. Suppliers will no longer have a guide for this room.",
        delete: 'Delete',
        addNew: {
          title: 'Add Room',
          roomName: 'Room name',
          roomPlaceholder: 'E.g. Guest bedroom',
          notes: 'Notes',
          notesPlaceholder: 'E.g. Frame including the sofa',
          save: 'Save',
        },
        emptyState: {
          title: 'No reference photos',
          subtitle: 'Add photos to help suppliers arrange rooms correctly.',
          cta: 'Add first photo',
        },
        rooms: {
          soggiorno: 'Living Room',
          cucina: 'Kitchen',
          bagno: 'Bathroom',
          camera1: 'Bedroom 1',
          camera2: 'Bedroom 2',
          ingresso: 'Entrance',
        },
      },
    },
    welcome: {
      greeting: '👋',
      title: 'How can we help you?',
      subtitle: 'How can we help you today?',
      subtitle_translated:
        'Use this tool to report a problem that needs attention',
      categories: {
        cleaning: {
          title: 'Cleaning',
          desc: 'Dirt, stains, supplies',
        },
        repair: {
          title: 'Repair',
          desc: 'Broken items, malfunctions, repairs',
        },
      },
    },
    wizard: {
      steps: {
        room: 'Room',
        details: 'Details',
        review: 'Review',
      },
    },
    roomSelection: {
      title: 'Select Room',
      subtitle: 'Where is the problem located?',
      rooms: {
        kitchen: 'Kitchen',
        bedroom: 'Bedroom',
        bathroom: 'Bathroom',
        livingRoom: 'Living Room',
        laundry: 'Laundry',
        other: 'Other',
      },
    },
    problemDescription: {
      title: 'Describe the Problem',
      subtitle:
        'Provide as many details as possible to help us resolve the issue',
      labels: {
        description: 'Description',
        photos: 'Photos',
        photosCount: '{count}/3 photos added',
      },
      placeholders: {
        description: 'Describe the problem in detail...',
      },
      buttons: {
        addPhoto: 'Add Photo',
      },
      urgency: {
        question: 'Does the problem completely prevent usage?',
        yes: 'Yes, cannot use room/appliance',
        no: 'No, can still use with discomfort',
      },
      validation: {
        photoRequired: 'Add at least 1 photo',
        urgencyRequired: 'Select an answer',
        descriptionTooShort: 'Description must be at least 20 characters',
        descriptionTooLong: 'Description cannot exceed 1000 characters',
      },
      characterCount: '{current}/{max} characters',
      photoTips: {
        title: 'Tips for a helpful photo',
        tip1: 'Frame the entire problem, not just a detail',
        tip2: 'Ensure good lighting',
        tip3: 'Take close-up to show details',
        tip4: 'If possible, show surrounding context',
        cancel: 'Cancel',
        openCamera: 'Open Camera',
      },
    },
    reviewSubmit: {
      title: 'Review Your Report',
      subtitle: 'Please verify all information before submitting',
      sections: {
        roomNumber: 'Room Number',
        location: 'Location',
        problem: 'Problem Description',
        contact: 'Contact Information',
      },
      labels: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        enterRoomNumber: 'Enter room number',
      },
      note: {
        title: 'Important Note',
        text: 'By submitting this report, you confirm that all information provided is accurate. Our maintenance team will review your request and contact you within 24-48 hours.',
      },
    },
    confirmation: {
      title: 'Thank You!',
      message: 'Your report has been successfully submitted.',
      infoTitle: 'Our team has been notified',
      button: 'Back to Home',
    },
  },
}
